import React from 'react';
import './RoadblocksFeatureSection.css';

// Sleek SVG Icons
const Icons = {
  Cpu: (props) => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect width="16" height="16" x="4" y="4" rx="2" />
      <rect width="6" height="6" x="9" y="9" rx="1" />
      <path d="M15 2v2" />
      <path d="M15 20v2" />
      <path d="M2 15h2" />
      <path d="M2 9h2" />
      <path d="M20 15h2" />
      <path d="M20 9h2" />
      <path d="M9 2v2" />
      <path d="M9 20v2" />
    </svg>
  ),
  Sparkles: (props) => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
      <path d="M5 3v4" />
      <path d="M19 17v4" />
      <path d="M3 5h4" />
      <path d="M17 19h4" />
    </svg>
  ),
  Layers: (props) => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" />
      <path d="m22 12.5-8.58 3.91a2 2 0 0 1-1.66 0L3.18 12.5" />
      <path d="m22 17.5-8.58 3.91a2 2 0 0 1-1.66 0L3.18 17.5" />
    </svg>
  ),
  Zap: (props) => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
    </svg>
  ),
};

const marqueeRow1 = [
  "How do I draft a strategic turnaround plan for a SaaS startup?",
  "What's the best AI prompt architecture for deep research?",
  "Can Ivori synthesize 50 pages of financial reports in seconds?",
  "How do I evaluate complex trade-offs in product architecture?",
  "What key metrics determine product-market fit in Fintech?",
  "How do multi-agent AI systems collaborate on complex tasks?",
];

const marqueeRow2 = [
  "Can Ivori simulate a board meeting scenario for my pitch?",
  "How do I debug distributed microservices with AI reasoning?",
  "What AI models work best for unstructured data extraction?",
  "How do top founders model unit economics under inflation?",
  "What framework breaks down ethical dilemmas in AI deployment?",
  "How do I formulate a winning go-to-market strategy?",
];

const marqueeRow3 = [
  "What's the most effective approach for diagnostic root-cause analysis?",
  "How do I evaluate global macroeconomic policy shocks?",
  "How can AI assist in drafting regulatory compliance docs?",
  "How do I build structured arguments for executive reviews?",
  "What strategic levers drive successful M&A integrations?",
  "How do I optimize prompt workflows for enterprise AI?",
];

const featuresData = [
  {
    icon: Icons.Cpu,
    title: "Universal AI Assistant",
    description:
      "Connect with state-of-the-art AI models for chat, reasoning, coding, and strategic synthesis — built for professionals, creators, and teams.",
  },
  {
    icon: Icons.Sparkles,
    title: "Deep Reasoning & Artifacts",
    description:
      "Go beyond simple answers. Ivori generates structured documents, interactive visual widgets, and live code artifacts in real time.",
  },
  {
    icon: Icons.Layers,
    title: "Interactive AI Simulations",
    description:
      "Test complex decision scenarios across business, tech, law, and medicine with real-time AI roleplay and instant diagnostic feedback.",
  },
  {
    icon: Icons.Zap,
    title: "Dedicated Edu Workspace",
    description:
      "Looking for exam prep, UCAT/TMUA prep, or student learning apps? Access our dedicated academic platform at ivoriai.com/edu.",
  },
];

export const PromptMarquee = () => {
  return (
    <div className="roadblocks-marquee-wrapper">
      <div className="marquee-fade-left" />
      <div className="marquee-fade-right" />

      <div className="marquee-rows-container">
        {/* Row 1 */}
        <div className="marquee-track marquee-track-1">
          {[...marqueeRow1, ...marqueeRow1, ...marqueeRow1, ...marqueeRow1].map((q, i) => (
            <span className="marquee-badge" key={`r1-${i}`}>
              {q}
            </span>
          ))}
        </div>

        {/* Row 2 (Reverse) */}
        <div className="marquee-track marquee-track-2">
          {[...marqueeRow2, ...marqueeRow2, ...marqueeRow2, ...marqueeRow2].map((q, i) => (
            <span className="marquee-badge" key={`r2-${i}`}>
              {q}
            </span>
          ))}
        </div>

        {/* Row 3 */}
        <div className="marquee-track marquee-track-3">
          {[...marqueeRow3, ...marqueeRow3, ...marqueeRow3, ...marqueeRow3].map((q, i) => (
            <span className="marquee-badge" key={`r3-${i}`}>
              {q}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export const RoadblocksFeatureSection = () => {
  return (
    <section className="roadblocks-section">
      <div className="roadblocks-container">
        {/* Header Block */}
        <div className="roadblocks-header">
          <h2 className="roadblocks-title">
            Supercharge your workflow with Ivori AI
          </h2>
          <p className="roadblocks-subtitle">
            From instant AI chat and deep reasoning to interactive case sandboxes and automated workflows — Ivori provides the intelligence to solve your hardest problems.
          </p>

          {/* Marquee Wrapper */}
          <PromptMarquee />
        </div>

        {/* 4 Feature Columns Grid */}
        <div className="roadblocks-features-grid">
          {featuresData.map((feature, idx) => {
            const IconComponent = feature.icon;
            return (
              <div className="roadblock-feature-card" key={idx}>
                <IconComponent className="roadblock-icon" />
                <div className="roadblock-card-text">
                  <h3 className="roadblock-card-title">{feature.title}</h3>
                  <p className="roadblock-card-desc">{feature.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RoadblocksFeatureSection;
